var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.href)?_c('a',{class:( _obj = {
    'c-button c-button--link': true
  }, _obj['c-button--' + _vm.type] = _vm.type, _obj[_vm.extraClass] = _vm.extraClass, _obj ),attrs:{"href":_vm.href,"target":_vm.target}},[_vm._t("default")],2):_c('button',{class:( _obj$1 = {
    'c-button c-button--button': true
  }, _obj$1['c-button--' + _vm.type] = _vm.type, _obj$1['c-button--disabled'] = _vm.disabled, _obj$1[_vm.extraClass] = _vm.extraClass, _obj$1 ),attrs:{"type":_vm.nativeType,"disabled":_vm.disabled}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }